import { GetterTree } from 'vuex';
import { AlumniProfileState } from './state';
import RootState from '@/store/root_state';
import i18n from '../../../i18n';
import Vue from 'vue';

const getters: GetterTree<AlumniProfileState, RootState> = {
  currentAlumniProfile: (state) => {
    const profile = state.profileToken ? state.alumniProfile : undefined;

    return profile || {};
  },
  isAlumniProfileLogged: (state) => {
    return !!state.profileToken;
  },
  currentUserAvatar: (state) => {
    const profile = state.profileToken ? state.alumniProfile : undefined;
    if (!profile) return undefined;

    return profile.avatarUrl ? profile.avatarUrl : '';
  },
  currentUserSettings: (state) => {
    const profile = state.profileToken ? state.alumniProfile : undefined;
    return profile?.userSettings || { shouldAutoPauseVideo: true };
  },
  currentUserInteraction: (state) => {
    const profile = state.profileToken ? state.alumniProfile : undefined;
    return profile?.userInteraction;
  },
  currentUserName: (state, alumniProfileGetters) => {
    const profile = state.profileToken ? state.alumniProfile : undefined;
    const user = alumniProfileGetters.currentUser;

    if (!profile) return undefined;

    const { firstName, lastName } = profile;

    if (firstName && lastName) {
      return profile.firstName.concat(' ', profile.lastName);
    }

    if (user && user.name) return user.name;

    return i18n.t('descomplicaStudent');
  },
  profilesByDexId: (state) => (profileDexId: number) => {
    return state.profiles[profileDexId.toString()];
  },
  profilesById: (state) => {
    const profilesObjectbyId: { [key: string]: any } = {};

    Object.keys(state.profiles)
      .map((dexId) => state.profiles[dexId])
      .forEach((profile) =>
        Vue.set(profilesObjectbyId, profile.id.toString(), {
          ...profilesObjectbyId[profile.id],
          ...profile,
        }),
      );

    return profilesObjectbyId;
  },
};

export default getters;
